import { createSlice } from "@reduxjs/toolkit";

export const AuthentificationInitialState = {
  loggedInUser: undefined,
  isLoggedIn: false,
  userId: undefined,
  email:undefined,
  token: undefined,
  refreshToken: undefined,
  rememberMe:false,
  userPermissions: [],
};

export const authentificationSlice = createSlice({
  name: "authentification",
  initialState: AuthentificationInitialState,
  reducers: {
    setLoggedInUser: (state, action) => {
      state.isLoggedIn = true;
      // here i will delete password from user object
      const user = action.payload.user;
      delete user.Mot_de_passe;

      state.loggedInUser = user;

      state.userId = action.payload.user.IDUser;
    },

    setUserId: (state, action) => {
      state.userId = action.payload.userId;
    },
    setEmailRedux: (state, action) => {
      state.email = action.payload.email;
    },
    setToken: (state, action) => {
      state.token = action.payload.token;
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload.refreshToken;
    },
    setRememberMe: (state, action) => {
      state.rememberMe = action.payload.rememberMe;
    },
    setUserPermissions: (state, action) => {
      state.userPermissions = action.payload.userPermissions;
    },

    disconnect: (state) => {
      state.loggedInUser = undefined;
      state.isLoggedIn = false;
      state.userId = undefined;
      state.token = undefined;
      state.userPermissions = [];
    },
  },
});

export const { setLoggedInUser, setToken, setRefreshToken,setRememberMe,disconnect, setUserPermissions,setUserId,setEmailRedux } =
  authentificationSlice.actions;
